import { getRuntimeSubdomain } from './runtimeConfig';

const getSubdomain = hostname => {
  return getRuntimeSubdomain(hostname);
};

export default getSubdomain;
